import { all, takeLatest, call, put } from 'redux-saga/effects'
import { decode } from 'jsonwebtoken'
import api from '@/services/api'
import bff from '@/services/bff'
import { signInRequestSuccess, signInRequestFailure, signOutRequest, signInRejection } from './actions'
import reportApi from '@/services/reportApi'
import { ALLOWED_LOGIN_ROLES } from '@/utils/constants'
import { postSignIn } from 'services/authServices'

function* signIn({ payload }) {
  try {
    const response = yield call(postSignIn, payload)
    if (!response.response) {
      yield put(signInRequestFailure(response.error.response))
      return
    }
    //    if (!response?.response?.data?.auth) throw Error("Não autenticado");
    const { accessToken, refreshToken } = response.response?.data?.auth
    const openAccessToken = decode(accessToken)
    const { role } = openAccessToken
    if (role === ALLOWED_LOGIN_ROLES) {
      api.defaults.headers.common.Authorization = `Bearer ${accessToken}`
      bff.defaults.headers.common.Authorization = `Bearer ${accessToken}`
      reportApi.defaults.headers.common.Authorization = `Bearer ${accessToken}`
      localStorage.setItem(
        'account',
        JSON.stringify({
          auth: response.response?.data?.auth,
          user: response.response?.data?.user,
          resale: response.response?.data?.resale,
        }),
      )
      yield put(
        signInRequestSuccess(accessToken, refreshToken, {
          ...openAccessToken,
          user: response.response?.data?.user,
          resale: response.response?.data?.resale,
        }),
      )
    } else {
      yield put(signInRejection())
    }
  } catch (error) {
    yield put(signInRequestFailure(error))
  }
}

function* setToken({ payload }) {
  if (!payload) return

  const { token } = payload.auth

  if (token) {
    const { exp: tokenExpiration } = decode(token)
    if (tokenExpiration <= Math.floor(Date.now() / 1000)) return yield put(signOutRequest())

    api.defaults.headers.common.Authorization = `Bearer ${token}`
    bff.defaults.headers.common.Authorization = `Bearer ${token}`
    reportApi.defaults.headers.common.Authorization = `Bearer ${token}`
  }
}

function signOut({ payload }) {
  api.defaults.headers.common.Authorization = ``
  bff.defaults.headers.common.Authorization = ``
  reportApi.defaults.headers.common.Authorization = ``
}

export default all([
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_OUT', signOut),
  localStorage.removeItem('account'),
])
